<template>
  <div style="height: 60vh"> 
    <div class="title" style="height: 3vh">D5/D6 Corrective and Preventive Actions</div>
    <div style="height: 100%;" class="bad-scroll">
      <table class="table-wrapper" >
        <thead>
          <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th style="width:5%">#</th>
            <th style="width:50%">Action Plan</th>
            <th style="width:15%">Owner</th>
            <th style="width:15%">Status</th>
            <th style="width:15%">Due Date</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(me, i) in dataList">
            <tr style="height:4vh;">
              <td :key="i">{{ (i + 1) }}</td>
              <td>{{ me.title }}</td>
              <td>{{ me.owner }}</td>
              <td>{{ me.status == 0 ? "未完成" : "完成" }}</td>
              <td>{{ formatDate(me.dueDate) }}</td>
            </tr>
          </template>
          <template v-if="dataList.length < 15">
            <tr style="height:4vh;" v-for="(me, i) in (15 - dataList.length)" :key="i">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import format from "date-fns/format";
export default {
  name: "fr6d",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["d5"]) {
          this.dataList = val["d5"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList: [],
      startCharts: null,
    };
  },
  mounted() { },
  methods: {
    formatDate(time) {
      if (time) {
        console.log(time);
        var date = new Date(Number(time));
        return format(date, "yyyy.MM.dd");
      }
      return "";
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper>thead {
  position: sticky;
  top: 0;
}

.table-wrapper>thead>tr>th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 15px;
}

.table-wrapper>tbody>tr>td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  font-weight: bold;
  padding: 4px 0;
  text-align: center;
  font-size: 13px;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #909090;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/8d/component/6d.vue